import * as R from "ramda"
import get from "lodash/get"
import map from "lodash/map"
import commonApiAuthRequest from "../apiAuthRequest"
import { SAP_LOADER_SERVICE_URL, TOIR_SERVICE_URL } from "./constants"

/*
  Спека
  https://next.stoplight.io/infotech-group/toro-reference-integration/version%2F1.0/toro-sap-loader.oas2.yml?view=%2Freference%2Fget-defects%2Fget-defects
*/

const defectsFetch = sapIssueId =>
  commonApiAuthRequest({
    url: `${SAP_LOADER_SERVICE_URL}/get_issue_to_defects`,
    method: `post`,
    data: {
      where: {
        issueId: sapIssueId,
      },
    },
  })

const defectsListFetch = defectFetchQueryString =>
  commonApiAuthRequest({
    url: `${TOIR_SERVICE_URL}/defect`,
    params: {
      query: defectFetchQueryString,
    },
  })

/**
 * makes request to get planned defects by sapIssueId
 *
 * @param {number} sapIssueId
 * @return {Array.<Object>} response - array of planned defects
 */
export const getPlannedDefects = async sapIssueId => {
  if (!sapIssueId) {
    return undefined
  }

  const { data: plannedDefects } = await defectsFetch(sapIssueId)

  const defectFetchQueryString = R.isEmpty(plannedDefects)
    ? ``
    : map(
        plannedDefects,
        defect =>
          `(defectMessagePositionNumber==${get(
            defect,
            `messagePositionNumber`,
          )};defectMessageNumber==${get(defect, `messageNumber`)})`,
      ).join()

  const { data: plannedDefectsList } = await defectsListFetch(
    defectFetchQueryString,
  )

  return plannedDefectsList
}
